import link from '@motionelements/core/src/helpers/link.js';

const helpCenterUrl = 'https://help.motionelements.com';
const contributorDocks = `${helpCenterUrl}/contributor/docs`;

function helpCenterMediaTypeLink(mediaType) {
  let mediaTypeGuide = '';
  switch (mediaType) {
    case 'ae':
      mediaTypeGuide = 'guide-for-selling-after-effects-template';
      break;
    case 'pr':
      mediaTypeGuide = 'guide-for-selling-premiere-pro-template';
      break;
    case 'video':
    case 'animation':
    case 'video_live':
      mediaTypeGuide = 'guide-for-selling-stock-video';
      break;
    case 'music':
    case 'sfx':
      mediaTypeGuide = 'guide-for-selling-music-and-sound-effects';
      break;
    case 'photo':
    case 'vector':
      mediaTypeGuide = 'guide-for-selling-photo-and-vector';
      break;
    case '3d_model':
      mediaTypeGuide = 'guide-for-selling-3d-model';
      break;
    case 'lottie':
      mediaTypeGuide = 'guide-for-selling-lottie-animation-bodymovin';
      break;
    case 'resolve':
      mediaTypeGuide = '';
      break;
    case 'fcp':
      mediaTypeGuide = 'guide-for-selling-fcp-apple-motion-template';
      break;
    case 'graphic_template':
      mediaTypeGuide = 'guide-for-selling-design-template';
      break;
    case 'ui_template':
      mediaTypeGuide = 'guide-for-selling-ui-ux-template';
      break;
    case 'presentation_template':
      mediaTypeGuide = 'guide-for-selling-presentation-template';
      break;
    case 'notion_template':
      mediaTypeGuide = 'guide-for-selling-notion-template';
      break;
    // no default
  }
  return link(`${contributorDocks}/${mediaTypeGuide}`).url();
}

function helpCenterGcpProgramLink(program) {
  let gcpProgramGuide;
  // eslint-disable-next-line
  switch (program) {
    case 'gcp_subscription':
      gcpProgramGuide = 'what-is-the-marketplace-subscription-plan';
      break;
    case 'gcp_apac_marketplace_partners':
      gcpProgramGuide = 'what-is-the-apac-marketplace-partners';
      break;
    case 'gcp_api_edit':
      gcpProgramGuide = 'what-is-video-editing-platforms-api-plan';
      break;
      // no default
  }
  return link(`${contributorDocks}/${gcpProgramGuide}`).url();
}

function helpCenterContributorDocs(article) {
  let articleLink;
  switch (article) {
    case '':
      articleLink = '';
      break;
    default:
      articleLink = article;
  }
  return link(`${contributorDocks}/${articleLink}`).url();
}

export { helpCenterMediaTypeLink, helpCenterGcpProgramLink, helpCenterContributorDocs };
